/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

export const ListItemStyled = styled.li`
  padding-bottom: ${rem(16)};
`;
